import { filesize } from 'filesize';
import { isFunction } from '../../../helpers/general-helpers';
import TimesIcon from '../../Icons/TimesIcon';
import styles from './AddedFile.module.scss';
import { FileExtension } from '../models/FileExtension';
import FilePdfIcon from '../../Icons/FilePdfIcon';
import FileWordIcon from '../../Icons/FileWordIcon';
import FileImageIcon from '../../Icons/FileImageIcon';
import FileIcon from '../../Icons/FileIcon';
import type { IValidationError } from '../models/IValidationErrors';
import Download from '../../Icons/Download';
import ValidationMessage from '../../ValidationMessage/ValidationMessage';

export interface IFile {
  key: string;
  file: File;
}

export interface IAddedFileProps {
  parentId: string;
  errors?: IValidationError[];
  file: IFile;
  onRemove: (id: string) => void;
}

export default function AddedFile({ errors = [], file, onRemove }: IAddedFileProps) {
  const { name, size } = file.file;
  const displayFileSize = filesize(size, { standard: 'jedec' });

  const fileExtension = name.split('.').pop() as FileExtension;

  function removeFile() {
    if (isFunction(onRemove)) onRemove(file.key);
  }

  function downloadFile() {
    const url = URL.createObjectURL(file.file);
    const a = document.createElement('a');
    a.href = url;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  const isValid = errors.length === 0;

  return (
    <>
      <div className={styles['added-file']}>
        <div
          className={`${styles['file-information']} ${errors.length > 0 ? styles.invalidInput : ''}`}
        >
          <span className={`${styles['size-normal']}`}>
            {fileExtension === FileExtension.Pdf && <FilePdfIcon />}
            {(fileExtension === FileExtension.Doc || fileExtension === FileExtension.Docx) && (
              <FileWordIcon />
            )}
            {(fileExtension === FileExtension.Jpeg || fileExtension === FileExtension.Jpg) && (
              <FileImageIcon />
            )}
            {!Object.values(FileExtension).includes(fileExtension) && <FileIcon />}
          </span>
          <span className={`${styles['file-name']}`} title={name}>
            {name}
          </span>
          <span className={`${styles['file-size']}`}>{displayFileSize}</span>

          <button
            title="download"
            className={`${styles.download}`}
            type="button"
            aria-label={`Click here to download ${name} from the list of files to be uploaded`}
            onClick={downloadFile}
          >
            <span>
              <Download />
            </span>
          </button>

          <button
            className={`${styles.remove}`}
            type="button"
            aria-label={`Click here to remove ${name} from the list of files to be uploaded`}
            onClick={removeFile}
          >
            <span>
              <TimesIcon />
            </span>
          </button>
        </div>
      </div>
      <ValidationMessage isValid={isValid} errors={errors.map((error) => error.message)} />
    </>
  );
}
